import * as TK from 'components/search/ProfilesTab/translations/constants';
import { Translations } from 'translations/types';

export const profilesTabEnUsLocale: Translations = {
  [TK.PROFILES_TAB_LOADING_MORE]: 'Loading more profiles',
};
